"use strict";

var _classCallCheck = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var _require = require("../helpers/traversal"),
    isConnected = _require.isConnected,
    descendantsByHTMLLocalNames = _require.descendantsByHTMLLocalNames;

var _require2 = require("../helpers/internal-constants"),
    domSymbolTree = _require2.domSymbolTree;

var HTMLCollection = require("../generated/HTMLCollection");

var notImplemented = require("../../browser/not-implemented");

var _require3 = require("../../utils"),
    reflectURLAttribute = _require3.reflectURLAttribute;

var Event = require("../generated/Event"); // http://www.whatwg.org/specs/web-apps/current-work/#category-listed


var listedElements = new Set(["button", "fieldset", "input", "keygen", "object", "select", "textarea"]); // https://html.spec.whatwg.org/multipage/forms.html#category-submit

var submittableElements = new Set(["button", "input", "object", "select", "textarea"]);
var encTypes = new Set(["application/x-www-form-urlencoded", "multipart/form-data", "text/plain"]);
var methods = new Set(["get", "post", "dialog"]);
var constraintValidationPositiveResult = Symbol("positive");
var constraintValidationNegativeResult = Symbol("negative");

var HTMLFormElementImpl = /*#__PURE__*/function (_HTMLElementImpl) {
  _inherits(HTMLFormElementImpl, _HTMLElementImpl);

  var _super = _createSuper(HTMLFormElementImpl);

  function HTMLFormElementImpl() {
    _classCallCheck(this, HTMLFormElementImpl);

    return _super.apply(this, arguments);
  }

  _createClass(HTMLFormElementImpl, [{
    key: "_descendantAdded",
    value: function _descendantAdded(parent, child) {
      var form = this;

      var _iterator = _createForOfIteratorHelper(domSymbolTree.treeIterator(child)),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var el = _step.value;

          if (typeof el._changedFormOwner === "function") {
            el._changedFormOwner(form);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      _get(_getPrototypeOf(HTMLFormElementImpl.prototype), "_descendantAdded", this).apply(this, arguments);
    }
  }, {
    key: "_descendantRemoved",
    value: function _descendantRemoved(parent, child) {
      var _iterator2 = _createForOfIteratorHelper(domSymbolTree.treeIterator(child)),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var el = _step2.value;

          if (typeof el._changedFormOwner === "function") {
            el._changedFormOwner(null);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      _get(_getPrototypeOf(HTMLFormElementImpl.prototype), "_descendantRemoved", this).apply(this, arguments);
    }
  }, {
    key: "_doSubmit",
    value: function _doSubmit() {
      if (!isConnected(this)) {
        return;
      }

      var ev = this._ownerDocument.createEvent("HTMLEvents");

      ev.initEvent("submit", true, true);

      if (this.dispatchEvent(ev)) {
        this.submit();
      }
    }
  }, {
    key: "submit",
    value: function submit() {
      notImplemented("HTMLFormElement.prototype.submit", this._ownerDocument._defaultView);
    }
  }, {
    key: "reset",
    value: function reset() {
      var _iterator3 = _createForOfIteratorHelper(this.elements),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var el = _step3.value;

          if (typeof el._formReset === "function") {
            el._formReset();
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "checkValidity",
    // If the checkValidity() method is invoked, the user agent must statically validate the
    // constraints of the form element, and return true if the constraint validation returned
    // a positive result, and false if it returned a negative result.
    value: function checkValidity() {
      return this._staticallyValidateConstraints().result === constraintValidationPositiveResult;
    } // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#interactively-validate-the-constraints

  }, {
    key: "reportValidity",
    value: function reportValidity() {
      return this.checkValidity();
    } // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#statically-validate-the-constraints

  }, {
    key: "_staticallyValidateConstraints",
    value: function _staticallyValidateConstraints() {
      var controls = [];

      var _iterator4 = _createForOfIteratorHelper(domSymbolTree.treeIterator(this)),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var el = _step4.value;

          if (el.form === this && submittableElements.has(el.nodeName.toLowerCase())) {
            controls.push(el);
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      var invalidControls = [];

      for (var _i = 0, _controls = controls; _i < _controls.length; _i++) {
        var control = _controls[_i];

        if (control._isCandidateForConstraintValidation() && !control._satisfiesConstraints()) {
          invalidControls.push(control);
        }
      }

      if (invalidControls.length === 0) {
        return {
          result: constraintValidationPositiveResult
        };
      }

      var unhandledInvalidControls = [];

      for (var _i2 = 0, _invalidControls = invalidControls; _i2 < _invalidControls.length; _i2++) {
        var invalidControl = _invalidControls[_i2];
        var notCancelled = invalidControl.dispatchEvent(Event.createImpl(["invalid", {
          cancelable: true
        }]));

        if (notCancelled) {
          unhandledInvalidControls.push(invalidControl);
        }
      }

      return {
        result: constraintValidationNegativeResult,
        unhandledInvalidControls: unhandledInvalidControls
      };
    }
  }, {
    key: "elements",
    get: function get() {
      var _this = this;

      return HTMLCollection.createImpl([], {
        element: this,
        query: function query() {
          return descendantsByHTMLLocalNames(_this, listedElements);
        }
      });
    }
  }, {
    key: "length",
    get: function get() {
      return this.elements.length;
    }
  }, {
    key: "method",
    get: function get() {
      var method = this.getAttribute("method");

      if (method) {
        method = method.toLowerCase();
      }

      if (methods.has(method)) {
        return method;
      }

      return "get";
    },
    set: function set(V) {
      this.setAttribute("method", V);
    }
  }, {
    key: "enctype",
    get: function get() {
      var type = this.getAttribute("enctype");

      if (type) {
        type = type.toLowerCase();
      }

      if (encTypes.has(type)) {
        return type;
      }

      return "application/x-www-form-urlencoded";
    },
    set: function set(V) {
      this.setAttribute("enctype", V);
    }
  }, {
    key: "action",
    get: function get() {
      var attributeValue = this.getAttribute("action");

      if (attributeValue === null || attributeValue === "") {
        return this._ownerDocument.URL;
      }

      return reflectURLAttribute(this, "action");
    },
    set: function set(V) {
      this.setAttribute("action", V);
    }
  }]);

  return HTMLFormElementImpl;
}(HTMLElementImpl);

module.exports = {
  implementation: HTMLFormElementImpl
};